import type { Song } from "@/types/song"

/**
 * 우선순위: 로컬 수동 오버라이드 > Sheets/API의 artworkUrl(fetchArtwork로 채움)
 * > 빌드 시점에 번들된 iTunes 스냅샷.
 */
export function getArtworkUrl(song: Song): string | null {
  return song.artworkUrl ?? null
}
